import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import Button from "../../componentes/button/button";

const TIPOS_ACEITOS = ["image/png", "image/jpeg"];

export default function UploadAssinatura({ onSalvar, salvando }) {
    const inputRef = useRef(null);
    const [arquivo, setArquivo] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
        };
    }, [previewUrl]);

    function selecionar(novoArquivo) {
        if (!novoArquivo) return;
        if (!TIPOS_ACEITOS.includes(novoArquivo.type)) {
            toast.error("Formato inválido. Selecione uma imagem PNG ou JPG.");
            return;
        }
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        setArquivo(novoArquivo);
        setPreviewUrl(URL.createObjectURL(novoArquivo));
    }

    function trocar() {
        setArquivo(null);
        setPreviewUrl(null);
        if (inputRef.current) inputRef.current.value = "";
        inputRef.current?.click();
    }

    function salvar() {
        onSalvar(arquivo).then(() => {
            setArquivo(null);
            setPreviewUrl(null);
        }).catch(() => {});
    }

    return (
        <div className="flex flex-col gap-3">
            <input
                ref={inputRef}
                type="file"
                accept="image/png,image/jpeg,image/jpg"
                className="hidden"
                onChange={e => selecionar(e.target.files?.[0])}
            />

            {!arquivo ? (
                <div
                    onClick={() => inputRef.current?.click()}
                    className="flex flex-col items-center justify-center gap-1.5 border-2 border-dashed border-border rounded-lg py-6 px-4 text-center cursor-pointer hover:border-primary/50 hover:bg-muted transition-colors duration-150"
                >
                    <i className="fas fa-image text-2xl text-primary/70" />
                    <p className="text-sm text-foreground font-medium">Clique para selecionar uma imagem (PNG ou JPG)</p>
                </div>
            ) : (
                <div className="border border-border rounded-lg p-3 bg-muted flex flex-col gap-3">
                    <img src={previewUrl} alt="Pré-visualização da assinatura" className="max-h-40 mx-auto object-contain bg-white rounded" />
                    <div className="flex justify-end gap-2">
                        <Button variant="outline" label="Trocar imagem" iconLeft="fa fa-sync" onClick={trocar} disabled={salvando} />
                        <Button label="Salvar" iconLeft="fa fa-check" onClick={salvar} loading={salvando} />
                    </div>
                </div>
            )}
        </div>
    );
}
